export const categories = [
  {
    slug: 'guobiao',
    name: '国标麻将',
    description: '国家体育总局认证的标准麻将玩法，含81个番种，考验技巧与策略的终极挑战。',
    icon: 'ri-medal-line',
    playerCount: '2-4人',
    difficulty: '进阶',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20mahjong%20tiles%20arranged%20on%20a%20dark%20green%20felt%20table%2C%20warm%20ambient%20lighting%2C%20elegant%20game%20room%20atmosphere%2C%20authentic%20Chinese%20culture%2C%20professional%20photography%2C%20soft%20shadows%2C%20rich%20textures%2C%20ornate%20tile%20designs%20with%20golden%20accents&width=600&height=400&seq=cat-guobiao&orientation=landscape',
  },
  {
    slug: 'guangdong',
    name: '广东麻将',
    description: '流行于珠三角地区的经典玩法，鸡平胡、推倒胡等多种变体，简单易上手乐趣多。',
    icon: 'ri-compasses-2-line',
    playerCount: '4人',
    difficulty: '入门',
    image: 'https://readdy.ai/api/search-image?query=Cantonese%20style%20mahjong%20game%20setup%20with%20colorful%20tiles%20on%20green%20felt%2C%20modern%20gaming%20room%2C%20warm%20golden%20lighting%2C%20casual%20social%20atmosphere%2C%20clean%20minimalist%20background%2C%20high%20quality%20product%20photography&width=600&height=400&seq=cat-guangdong&orientation=landscape',
  },
  {
    slug: 'sichuan',
    name: '四川麻将',
    description: '血战到底、血流成河！川麻独特的缺一门规则，刺激紧张的对局体验。',
    icon: 'ri-fire-line',
    playerCount: '4人',
    difficulty: '中级',
    image: 'https://readdy.ai/api/search-image?query=Sichuan%20style%20mahjong%20with%20vibrant%20red%20and%20green%20tiles%20on%20dark%20felt%20table%2C%20dramatic%20lighting%20with%20warm%20tones%2C%20intense%20gaming%20atmosphere%2C%20traditional%20Chinese%20elements%2C%20high%20contrast%20photography%2C%20elegant%20composition&width=600&height=400&seq=cat-sichuan&orientation=landscape',
  },
  {
    slug: 'changsha',
    name: '长沙麻将',
    description: '湖南特色的麻将玩法，二五八做将，独特的胡牌规则带来不一样的游戏体验。',
    icon: 'ri-building-2-line',
    playerCount: '4人',
    difficulty: '中级',
    image: 'https://readdy.ai/api/search-image?query=Changsha%20style%20mahjong%20tiles%20with%20distinctive%20patterns%20on%20green%20felt%20table%2C%20warm%20cozy%20indoor%20setting%2C%20soft%20natural%20light%20from%20window%2C%20relaxed%20social%20gaming%20vibe%2C%20authentic%20Chinese%20domestic%20scene&width=600&height=400&seq=cat-changsha&orientation=landscape',
  },
  {
    slug: 'shanghai',
    name: '上海麻将',
    description: '清混碰，老上海的味道！海派麻将独特规则，兼具趣味性与策略性。',
    icon: 'ri-building-line',
    playerCount: '4人',
    difficulty: '入门',
    image: 'https://readdy.ai/api/search-image?query=Shanghai%20style%20mahjong%20elegant%20setup%20with%20ivory-colored%20tiles%20on%20dark%20green%20felt%2C%20art%20deco%20inspired%20room%2C%20sophisticated%20lighting%2C%20nostalgic%201930s%20Shanghai%20atmosphere%2C%20luxurious%20interior%20details&width=600&height=400&seq=cat-shanghai&orientation=landscape',
  },
  {
    slug: 'hongkong',
    name: '香港麻将',
    description: '港式麻将十三张经典玩法，快节奏对决，深受粤语地区玩家喜爱。',
    icon: 'ri-ship-line',
    playerCount: '4人',
    difficulty: '入门',
    image: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20style%20mahjong%20with%20classic%20tiles%20on%20green%20felt%20table%2C%20modern%20urban%20apartment%20setting%2C%20bright%20ambient%20lighting%2C%20casual%20gaming%20scene%2C%20clean%20composition%2C%20professional%20product%20photography&width=600&height=400&seq=cat-hongkong&orientation=landscape',
  },
];

export const articles = [
  {
    slug: 'mahjong-beginner-guide',
    title: '麻将入门完全指南：从零开始学会打麻将',
    excerpt: '刚接触麻将不知从何下手？本篇指南带你了解麻将基础规则、牌型组合和胡牌技巧，让你快速上手在线麻将牌。',
    category: 'guobiao',
    categoryName: '国标麻将',
    date: '2026-08-10',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Beginner%20friendly%20mahjong%20learning%20scene%20with%20instructional%20cards%20and%20tiles%20on%20green%20felt%2C%20bright%20clean%20lighting%2C%20educational%20atmosphere%2C%20warm%20inviting%20colors%2C%20professional%20photography%2C%20simple%20elegant%20composition&width=600&height=400&seq=art-beginner&orientation=landscape',
    content: `麻将是中国最受欢迎的棋牌游戏之一，拥有数百年的历史。对于初学者来说，麻将可能看起来复杂，但只要掌握了基本规则，你会发现它非常有趣。

## 麻将基础组成

一副标准麻将共有144张牌，分为以下几类：

### 序数牌（108张）
- **万子**：一万到九万，各4张，共36张
- **筒子**：一筒到九筒，各4张，共36张
- **条子**：一条到九条，各4张，共36张

### 字牌（28张）
- **风牌**：东、南、西、北，各4张，共16张
- **箭牌**：中、发、白，各4张，共12张

### 花牌（8张）
- 春、夏、秋、冬、梅、兰、竹、菊，各1张

## 基本术语

- **顺子**：同花色、数字连续的三张牌，如"一万、二万、三万"
- **刻子**：三张相同的牌，如"三张三万"
- **对子**：两张相同的牌，也称"将牌"
- **吃**：用上家打出的牌与手中两张牌组成顺子
- **碰**：用任意玩家打出的牌与手中两张相同牌组成刻子
- **杠**：四张相同的牌，分暗杠、明杠
- **听牌**：只差一张牌就能胡牌的状态
- **胡牌**：达成胜利条件，赢得本局

## 基本胡牌条件

标准国标麻将中，胡牌需要：
- 四组顺子或刻子 + 一对将牌（共14张）
- 满足一定的番数要求

## 在线麻将牌的优势

在在线麻将牌平台，系统会自动判断胡牌条件，帮你计算番数，让你专注于策略和乐趣。同时支持多种地方玩法，无论你喜欢国标、广东还是四川麻将，都能找到合适的对手。`,
  },
  {
    slug: 'sichuan-mahjong-strategy',
    title: '四川麻将血战到底高级策略：缺一门的选择艺术',
    excerpt: '四川麻将"血战到底"玩法中，缺哪一门是决定胜负的关键。本文深度分析如何根据手牌做出最优选择。',
    category: 'sichuan',
    categoryName: '四川麻将',
    date: '2026-08-08',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Strategic%20Sichuan%20mahjong%20game%20analysis%20with%20tiles%20arranged%20in%20patterns%20on%20dark%20green%20felt%2C%20dramatic%20overhead%20lighting%2C%20intense%20focus%20atmosphere%2C%20professional%20game%20photography%2C%20rich%20textures&width=600&height=400&seq=art-sichuan&orientation=landscape',
    content: `四川麻将"血战到底"以其独特的规则和刺激的玩法吸引了无数玩家。其中"缺一门"规则是川麻最核心的特色之一。

## 什么是缺一门？

在四川麻将中，玩家必须选择缺少万、筒、条三种花色中的一种，整局游戏中不能使用该花色的牌。这一规则大大增加了游戏的策略深度。

## 缺一门的选择策略

### 1. 根据手牌数量决策
摸完13张手牌后，统计各花色数量：
- **明显偏少的花色**（少于3张）：优先缺这一门
- **数量相当**（4-5张）：评估牌型和搭子质量
- **数量较多**（6张以上）：不建议缺这一门

### 2. 看搭子质量
不是单纯看数量，更要看牌的质量：
- 有二连搭子（如七八万）的花色优先保留
- 全是散牌的花色优先放弃
- 有对子的花色有碰牌机会，值得保留

### 3. 观察对手出牌
第一轮出牌后，观察上家缺什么：
- 如果上家缺万子，你保留万子更容易吃到牌
- 多人缺同一花色时，该花色价值降低

## 血战到底的核心战术

血战到底意味着即使有人先胡牌，游戏仍继续，直到只剩一人或牌墙摸完。关键战术：

1. **前期稳扎稳打**：不急于胡小牌，等待更好的机会
2. **中期关注局势**：已经胡牌的玩家退出后，重新评估剩余对手
3. **后期果断出手**：牌墙见底时，能胡就胡，不要贪大

在在线麻将牌平台练习川麻，系统会帮你追踪缺门状态，让你更专注于策略制定。`,
  },
  {
    slug: 'guangdong-mahjong-variants',
    title: '广东麻将三大变体详解：鸡平胡、推倒胡与清一色',
    excerpt: '广东麻将玩法丰富多变，本文详细对比鸡平胡、推倒胡等不同变体的规则差异和制胜技巧。',
    category: 'guangdong',
    categoryName: '广东麻将',
    date: '2026-08-05',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Guangdong%20mahjong%20variants%20display%20showing%20different%20winning%20hands%20on%20green%20felt%2C%20multiple%20tile%20arrangements%2C%20bright%20clean%20lighting%2C%20educational%20display%2C%20professional%20photography%2C%20organized%20composition&width=600&height=400&seq=art-guangdong&orientation=landscape',
    content: `广东麻将是中国最具影响力的地方麻将之一，玩法灵活多变，深受珠三角地区玩家喜爱。

## 鸡平胡

鸡平胡是广东麻将最基础的玩法：

### 规则特点
- 只允许碰牌，不允许吃牌
- 胡牌不设番数门槛，能胡就胡
- 自摸加一番
- 无花牌

### 基本策略
- 优先保留对子，增加碰牌机会
- 快速听牌是王道，不要追求大牌
- 注意防守，避免点炮

## 推倒胡

推倒胡比鸡平胡更加自由：

### 规则特点
- 允许吃、碰、杠
- 最宽松的胡牌条件
- 适合新手入门

### 基本策略
- 充分利用吃牌快速成型
- 关注上家出牌节奏
- 杠牌可以增加收益，但有风险

## 清一色玩法

清一色是广东麻将中的高分牌型：

### 规则特点
- 所有牌必须是同一花色
- 番数通常为6-8番
- 是许多玩家追求的目标牌型

### 制胜技巧
- 早期手牌中同花色超过8张时可考虑做清一色
- 做清一色时要留意对手防守
- 听牌后不要轻易改变牌型

在在线麻将牌平台，各种广东麻将变体一键切换，系统自动匹配相应规则，让你随时随地体验最正宗的广东麻将。`,
  },
  {
    slug: 'mahjong-history-culture',
    title: '麻将的前世今生：从清朝宫廷到在线麻将牌的文化之旅',
    excerpt: '麻将不仅是一种游戏，更是中华文化的瑰宝。追溯麻将的起源与发展，了解这项国民游戏的百年传奇。',
    category: 'guobiao',
    categoryName: '国标麻将',
    date: '2026-08-01',
    readTime: '12分钟',
    image: 'https://readdy.ai/api/search-image?query=Antique%20Chinese%20mahjong%20set%20with%20aged%20bamboo%20and%20bone%20tiles%20on%20dark%20wooden%20table%2C%20warm%20vintage%20lighting%2C%20historical%20Chinese%20artifacts%20in%20background%2C%20nostalgic%20atmosphere%2C%20rich%20cultural%20heritage%20photography&width=600&height=400&seq=art-history&orientation=landscape',
    content: `麻将被誉为"中国第五大发明"，这项凝聚了中华民族智慧的游戏，有着悠久而迷人的历史。

## 起源传说

关于麻将的起源，流传最广的说法是：

### 清朝宫廷说
相传麻将起源于清朝道光年间，最初是宫廷中的贵族游戏。当时的麻将称为"麻雀牌"，因为牌上的图案与麻雀有关。守卫粮仓的士兵发明了这种消遣方式，用筒代表火药枪、条代表绳索、万代表赏钱。

### 郑和下西洋说
另一种说法认为，麻将的雏形与明代郑和下西洋有关。船上的水手们为了打发漫长的航海时间，创造了这种四人游戏。

## 近代发展

20世纪初，麻将开始从中国走向世界：
- 1920年代，麻将在美国掀起热潮，被称为"Mah-Jongg"
- 日本在麻将基础上发展出"立直麻将"
- 1998年，国家体育总局正式颁布《中国麻将竞赛规则》
- 2017年，国际智力运动联盟将麻将列为世界智力运动项目

## 在线麻将牌的时代

随着互联网技术的发展，在线麻将牌让这项古老游戏焕发新生：
- 无需实体牌具，随时随地开局
- 智能匹配对手，告别三缺一的烦恼
- 多种地方玩法一站式体验
- 系统自动计分，公平公正

麻将不仅是游戏，更承载着中国人的社交文化和智慧结晶。在在线麻将牌，我们致力于传承这一文化瑰宝，让更多人感受麻将的魅力。`,
  },
  {
    slug: 'mahjong-tips-winning',
    title: '老玩家不告诉你的5个麻将赢牌秘诀',
    excerpt: '想提升麻将胜率？这些实战中总结出的赢牌技巧，帮你从菜鸟蜕变为高手。',
    category: 'guobiao',
    categoryName: '国标麻将',
    date: '2026-07-28',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20winning%20mahjong%20hand%20with%20tiles%20perfectly%20arranged%20on%20dark%20green%20felt%2C%20golden%20hour%20lighting%20creating%20dramatic%20shadows%2C%20victory%20atmosphere%2C%20premium%20product%20photography%2C%20sharp%20focus&width=600&height=400&seq=art-tips&orientation=landscape',
    content: `打麻将不只是运气，更多时候是技术和心态的较量。以下是五位麻将高手总结的赢牌秘诀。

## 秘诀一：开局三圈定方向

摸完牌后的前三圈至关重要：
- 快速评估手牌质量
- 确定本局打法是进攻还是防守
- 观察对手的出牌习惯和节奏

## 秘诀二：中间张优先保留

序数牌中的3-7被称为"中间张"：
- 中间张可以组成更多的顺子组合
- 边缘张（1、2、8、9）搭子数量少
- 不确定打什么时，优先打边缘张

## 秘诀三：听牌要"多面听"

听牌时选择听多张比听单张好：
- 单面听中张比听边张好
- 双面听胜率是单面的两倍
- 三面听几乎是必胜之局

## 秘诀四：读牌靠观察

通过对手出牌推测手牌：
- 对手连续打同一花色，可能在清一色
- 对手迟迟不出某一花色，可能在收集
- 注意对手吃碰后的舍牌变化

## 秘诀五：心态决定成败

这是最重要的一条：
- 输牌不气馁，赢牌不骄傲
- 保持冷静，每一局都是新的开始
- 享受游戏过程，而非只关注输赢

在在线麻将牌平台，你可以反复练习这些技巧，系统还提供对局回放功能，帮助你复盘分析，持续进步。`,
  },
  {
    slug: 'online-mahjong-etiquette',
    title: '在线麻将牌礼仪指南：做一名受欢迎的牌友',
    excerpt: '在线打麻将也要讲礼仪！了解在线麻将牌平台的社交礼仪，让你的游戏体验更加愉快。',
    category: 'guobiao',
    categoryName: '国标麻将',
    date: '2026-07-20',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Friendly%20online%20gaming%20community%20concept%2C%20warm%20social%20mahjong%20scene%20with%20modern%20tablet%20displaying%20mahjong%20game%2C%20cozy%20cafe%20setting%2C%20soft%20natural%20lighting%2C%20positive%20vibes%2C%20clean%20minimalist%20composition&width=600&height=400&seq=art-etiquette&orientation=landscape',
    content: `在线麻将虽然是虚拟对局，但良好的游戏礼仪同样重要。遵守以下礼仪，让每局游戏都愉快。

## 基本礼仪

### 准时准备
- 进入房间后尽快点击"准备"
- 不要让他人等待过久
- 如需离开，提前说明

### 文明聊天
- 使用友善的语言交流
- 不嘲讽、不辱骂对手
- 多用表情和快捷短语表达

### 尊重规则
- 遵守房间设定的规则
- 不利用漏洞或外挂
- 尊重不同地区的玩法差异

## 对局礼仪

### 出牌节奏
- 保持合理的出牌速度
- 不要故意拖延时间
- 遇到复杂决策时，使用"稍等"提示

### 胜负风度
- 赢牌时谦虚，不炫耀
- 输牌时不抱怨运气
- 对局结束说一声"谢谢"

## 社区贡献

### 帮助新手
- 耐心解答新手的疑问
- 分享自己的经验技巧
- 营造友好的学习氛围

### 积极反馈
- 遇到问题及时反馈
- 提出建设性的改进建议
- 参与社区活动

在在线麻将牌平台，我们倡导"快乐游戏、文明互动"的理念，希望每位玩家都能在这里找到家的感觉。`,
  },
];

export const faqs = [
  {
    question: '在线麻将牌是免费的吗？',
    answer: '是的，在线麻将牌完全免费！无需下载任何软件，打开浏览器即可开始游戏。我们提供基础的免费游戏币，让您可以畅享麻将乐趣。',
  },
  {
    question: '支持哪些麻将玩法？',
    answer: '我们支持多种地方麻将玩法，包括国标麻将、广东麻将（鸡平胡/推倒胡）、四川麻将（血战到底）、长沙麻将、上海麻将、香港麻将等。更多玩法持续更新中。',
  },
  {
    question: '可以在手机上玩吗？',
    answer: '当然可以！在线麻将牌采用响应式设计，完美适配手机、平板和电脑。无论您使用iOS还是Android设备，都能获得流畅的游戏体验。',
  },
  {
    question: '如何与朋友一起玩？',
    answer: '您可以创建私人房间，设置密码后邀请朋友加入。最多支持4人同时对战，还可以设置观战席位，让其他朋友观看比赛。',
  },
  {
    question: '游戏的公平性如何保证？',
    answer: '我们使用经过认证的随机洗牌算法，确保每局牌都是完全随机的。系统自动计分，杜绝人为干预，保证绝对公平公正。',
  },
  {
    question: '需要注册账号吗？',
    answer: '游客模式即可快速开始游戏。注册账号后可以保存游戏记录、积累积分、参与排行榜竞争，享受更多功能。',
  },
  {
    question: '游戏中遇到问题怎么办？',
    answer: '您可以通过网站底部的"联系我们"提交反馈，或发送邮件至我们的客服邮箱。我们会在24小时内回复您的问题。',
  },
];

export const testimonials = [
  {
    name: '张大爷',
    avatar: 'https://readdy.ai/api/search-image?query=Elderly%20Chinese%20man%20smiling%20warmly%2C%20portrait%20photography%2C%20soft%20natural%20light%2C%20friendly%20expression%2C%20plain%20background&width=120&height=120&seq=avatar-1&orientation=squarish',
    text: '退休后每天都要打几圈，在线麻将牌让我在家就能和老朋友们搓麻，操作简单，画面清晰，太方便了！',
    rating: 5,
  },
  {
    name: '小李',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20with%20warm%20smile%2C%20professional%20portrait%2C%20soft%20lighting%2C%20friendly%20and%20approachable%2C%20clean%20background&width=120&height=120&seq=avatar-2&orientation=squarish',
    text: '作为麻将新手，在线麻将牌的教程和攻略文章帮我快速入门，现在已经能跟高手过招了！',
    rating: 5,
  },
  {
    name: '老王',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%2C%20friendly%20confident%20expression%2C%20professional%20headshot%2C%20clean%20studio%20lighting%2C%20neutral%20background&width=120&height=120&seq=avatar-3&orientation=squarish',
    text: '玩了二十年麻将，在线麻将牌的血战到底模式最对我胃口，匹配速度快，对手水平高，每局都很刺激！',
    rating: 5,
  },
];